// Sport Workspaces v1.0 — active-sport hook. Reads the current route to infer
// which sport workspace is active, and exposes switchTo() to jump to another
// sport's home (the hero switcher's action). Pure logic lives in workspaces.ts.

import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SPORT_WORKSPACES,
  activeWorkspaceForPath,
  workspaceByKey,
  type SportWorkspace,
  type SportWorkspaceKey,
} from "./workspaces.ts";

export interface UseActiveSport {
  active: SportWorkspace;
  sports: readonly SportWorkspace[];
  switchTo: (key: SportWorkspaceKey) => void;
}

export function useActiveSport(): UseActiveSport {
  const location = useLocation();
  const navigate = useNavigate();
  const active = activeWorkspaceForPath(location.pathname);

  const switchTo = useCallback(
    (key: SportWorkspaceKey) => {
      if (key === active.key) return;
      navigate(workspaceByKey(key).home);
    },
    [active.key, navigate],
  );

  return { active, sports: SPORT_WORKSPACES, switchTo };
}
